function NRAnthropicDarkIcon({ height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6748 4H16.9775L23 19.1067H19.6973L13.6748 4ZM7.02158 4H10.4747L16.4972 19.1067H13.1293L11.8983 15.9341H5.59892L4.36692 19.1057H1L7.0225 4.00183L7.02158 4ZM10.8093 13.1291L8.74858 7.81975L6.68792 13.13H10.8083L10.8093 13.1291Z"
        fill="white"
      />
    </svg>
  );
}

export default NRAnthropicDarkIcon;
